import { BUTTON_SIZE, BUTTON_TYPE, DSButton } from '@repo/design-system/index'
import { QIcon_chevron_bold_right } from '@repo/icons/index'
import { HighlightItem } from '../../../../model/caf.interface'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import { n_caf } from '../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../modules/i18n/useTranslation'
import urls from '../../../../modules/urls'
import { COLORS } from '../../../../modules/vars'
import useHighlightSortedList from '../CAFOverview/utils/useHighlightSortedList'

type AdditionalListData = {
  zscore_sum: number
  average_count: number
  tag: number
}

type SortOption = {
  label: string
  value: number
  name: string
}

interface ListData extends Partial<HighlightItem>, AdditionalListData {}

interface HighlightsProps {
  data: ListData[]
  sortOption: SortOption
  setSelected: (tag: number, highlightId: number) => void
  setFilter?: (filter: 'all' | 'pinned') => void
  infoText?: string
  buttonText?: string
}

export const AllHighlights = ({ data, sortOption, setSelected }: HighlightsProps) => {
  const sortedList = useHighlightSortedList(data, sortOption, setSelected as any, false)
  if (!data || data.length === 0) return null
  return <>{sortedList}</>
}

const PinnedHighlightsEmptyComponent = ({ onClick }: any) => {
  const { t } = useTranslation()
  return (
    <div className="mt-[32px] flex h-[130px] w-[424px] flex-col items-center justify-between rounded-[6px] bg-gray-100 p-[16px]">
      <div className="w-[200px] text-center text-[14px] text-purple-500">{t(n_caf.overview.tophighlights_info)}</div>
      <div>
        <DSButton
          onClick={onClick}
          type={BUTTON_TYPE.OUTLINE}
          size={BUTTON_SIZE.SM}
          className="mx-auto border-purple-600"
        >
          <DSButton.Label className="text-purple-600">{t(n_caf.overview.checkout.btn)}</DSButton.Label>
        </DSButton>
      </div>
    </div>
  )
}

export const PinnedHighlights = ({
  data,
  sortOption,
  setSelected,
  setFilter,
  infoText,
  buttonText,
}: HighlightsProps) => {
  // const { t } = useTranslation()
  const router = useAppRouter()
  const sortedList = useHighlightSortedList(data, sortOption, setSelected as any, false)
  if (!data || data.length === 0) return <PinnedHighlightsEmptyComponent onClick={() => setFilter('all')} />
  const editHighlights = () => {
    const isStatistic =
      router.asPath.includes('/portal/lessons/caf') || router.asPath.includes('/portal/my-ringle/ai-analysis')
    const { startDate, endDate, tab } = router.query
    if (isStatistic) {
      // 통계
      router.push(urls.student.newPortal.myRingle.AIAnalysis.asEditWithDate(tab, startDate, endDate))
    } else {
      // 개별
      router.push(urls.student.newPortal.lessons.reviewDetail.asCafEditPopup(router.query?.lessonId, true))
    }
  }
  return (
    <>
      <div className="border-1 text-14 mt-[16px] flex w-[424px] items-center justify-between rounded-md border-gray-200 bg-gray-50 px-[16px] py-12 text-gray-700">
        <span>{infoText}</span>
        <div className="flex cursor-pointer flex-row items-center" onClick={editHighlights}>
          <span className="mr-1 text-[14px] font-bold text-black">{buttonText}</span>
          <QIcon_chevron_bold_right width={16} height={16} color={COLORS.GRAY500} className="pb-[2px]" />
        </div>
      </div>
      {sortedList}
    </>
  )
}
